import permissionsIcon from '@material-ui/icons/VpnKeyRounded';

import { PermissionsList } from './list';

export default {
	name: 'permissions',
	options: { label: 'Permissions', menuParent: '_system' },
	icon: permissionsIcon,
	list: PermissionsList
};